import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["canvas"]
  static values = {
    labels: Array,
    data: Array,
    label: String,
    color: { type: String, default: "#4f46e5" },
    type: { type: String, default: "bar" }
  }

  async connect() {
    const token = (this.connectToken = {})
    const { Chart } = await import("../../lib/chart")
    if (this.connectToken !== token) return

    const line = this.typeValue === "line"

    this.chart = new Chart(this.canvasTarget, {
      type: this.typeValue,
      data: {
        labels: this.labelsValue,
        datasets: [
          {
            label: this.labelValue,
            data: this.dataValue,
            // A line needs its colour on the stroke; a bar on the fill.
            backgroundColor: line ? `${this.colorValue}1a` : this.colorValue,
            borderColor: this.colorValue,
            borderRadius: 3,
            maxBarThickness: 32,
            borderWidth: line ? 2 : 0,
            fill: line,
            tension: line ? 0.3 : 0,
            pointRadius: line ? 2 : 0,
            pointHoverRadius: line ? 4 : 0
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            displayColors: false,
            callbacks: {
              label: (context) => `${context.parsed.y} ${this.labelValue}`
            }
          }
        },
        scales: {
          x: {
            grid: { display: false },
            ticks: { autoSkip: true, maxRotation: 0, color: "#6b7280" }
          },
          y: {
            beginAtZero: true,
            border: { display: false },
            grid: { color: "#f3f4f6" },
            ticks: { precision: 0, color: "#6b7280" }
          }
        }
      }
    })
  }

  disconnect() {
    this.connectToken = null
    // Turbo caches and restores the page, so an abandoned chart would keep its
    // canvas and resize listeners alive.
    this.chart?.destroy()
    this.chart = null
  }
}
